import React from "react";

const LeavePieChart = ({ data = [], totalDays = 0, usedDays: providedUsedDays = null, year, annualLeaves = 0 }) => {
    // Ensure we have valid numbers
    const remainingDays = Number(totalDays) || 0;
    const annualLeaveAllowance = Number(annualLeaves) || 0;

    // Use provided usedDays if available, otherwise calculate
    let usedDays = providedUsedDays !== null && !isNaN(providedUsedDays) ? Number(providedUsedDays) : null;

    // Calculate total allowance first
    let totalAllowance = annualLeaveAllowance;

    if (usedDays === null || isNaN(usedDays)) {
        // Calculate total used days from data if provided
        const totalUsedFromData = Array.isArray(data) ? data.reduce((sum, item) => sum + (item.value || 0), 0) : 0;

        // If no annual allowance provided, calculate from used + remaining
        if (totalAllowance <= 0) {
            totalAllowance = totalUsedFromData + remainingDays;
        }

        // Calculate used days from allowance and remaining
        usedDays = Math.max(0, totalAllowance - remainingDays);
    } else {
        // If usedDays is provided but no annual allowance, calculate it
        if (totalAllowance <= 0) {
            totalAllowance = usedDays + remainingDays;
        }
    }

    // Calculate percentage for used and remaining days
    const usedPercentage = totalAllowance > 0 ? Math.min(100, Math.max(0, (usedDays / totalAllowance) * 100)) : 0;
    const remainingPercentage = 100 - usedPercentage;

    // Calculate circumference (2 * π * radius)
    const radius = 60;
    const circumference = 2 * Math.PI * radius;

    // Calculate stroke-dasharray and stroke-dashoffset for used days (blue)
    // The blue portion shows used days (large portion), grey shows remaining
    const usedDashArray = circumference;
    // Ensure we have a valid offset (if no used days, show full grey circle)
    const usedDashOffset = usedPercentage > 0
        ? circumference - (usedPercentage / 100) * circumference
        : circumference; // Hide the blue arc if no used days

    // Get end date (December 31 of the year)
    const endDate = new Date(year, 11, 31); // Month 11 = December
    const endDateStr = `${endDate.getDate()} ${endDate.toLocaleString('default', { month: 'short' })}`;

    // Ensure we always show something - if totalAllowance is 0, show a default state
    const showChart = totalAllowance > 0 || remainingDays > 0;

    return (
        <div className="leave-pie-chart-container">

            <div className="pie-chart-wrapper">
                <svg width="140" height="140" viewBox="0 0 140 140" className="pie-chart-svg">
                    <defs>
                        <linearGradient id="usedDaysGradient" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor="#a5b4fc" />
                            <stop offset="100%" stopColor="#6366f1" />
                        </linearGradient>
                    </defs>
                    {/* Background circle (grey - remaining days) */}
                    <circle
                        cx="70"
                        cy="70"
                        r={radius}
                        fill="none"
                        stroke="#e5e7eb"
                        strokeWidth="12"
                    />
                    {/* Used days arc (amber - large portion) - only show if there are used days */}
                    {usedPercentage > 0 && (
                        <circle
                            cx="70"
                            cy="70"
                            r={radius}
                            fill="none"
                            stroke="url(#usedDaysGradient)"
                            strokeWidth="12"
                            strokeDasharray={usedDashArray}
                            strokeDashoffset={usedDashOffset}
                            strokeLinecap="round"
                            transform="rotate(-90 70 70)"
                            className="pie-chart-used"
                        />
                    )}
                </svg>
                <div className="pie-chart-center">
                    <div className="pie-chart-days">{remainingDays}</div>
                    <div className="pie-chart-label-text">days</div>
                    <div className="pie-chart-label-text-small">to use before</div>
                    <div className="pie-chart-label-text-small">{endDateStr}</div>
                </div>
            </div>
        </div>
    );
};

export default LeavePieChart;

